declare module '@mui/material/styles' {
  interface BreakpointOverrides {
    xxs: true;
    xs: true;
    sm: true;
    md: true;
    smplus: true;
    lg: true;
    xl: true;
    xxl: true;
  }
}

export const customBreakpoints = {
  xxs: 0,
  xs: 300,
  sm: 600,
  md: 900,
  smplus: 1024,
  lg: 1280,
  xl: 1920,
  xxl: 2500,
};
